import types from '../types'

const initialState = {
  getUser: {
    loading: false,
    success: false,
    error: false,
    data: {}
  },
  login: {
    loading: false,
    success: false,
    error: false,
    data: {}
  },
  logout: {
    loading: false,
    success: false,
    error: false
  },
  user: {},
  forgotPassword: {
    loading: false,
    success: false,
    error: false,
    data: {}
  },
  verifyUser: {
    loading: false,
    success: false,
    error: false
  },
  validateUser: {
    loading: false,
    success: false,
    error: false
  },
  resendCode: {
    loading: false,
    success: false,
    error: false
  },
  changePassword: {
    loading: false,
    success: false,
    error: false
  }
}

const userReducer = (state = initialState, action) => {
  switch (action.type) {
  case types.GET_USER_REQUESTED: {
    return {
      ...state,
      getUser: {
        loading: true,
        success: false,
        error: false,
        data: {}
      }
    }
  }
  case types.GET_USER_FULFILLED: {
    return {
      ...state,
      getUser: {
        ...state.getUser,
        loading: false,
        success: true,
        data: action.payload
      },
      user: action.payload
    }
  }
  case types.GET_USER_REJECTED: {
    return {
      ...state,
      getUser: {
        ...state.getUser,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.LOGIN_USER_REQUESTED: {
    return {
      ...state,
      login: {
        loading: true,
        success: false,
        error: false,
        data: []
      }
    }
  }
  case types.LOGIN_USER_FULFILLED: {
    return {
      ...state,
      login: {
        ...state.login,
        loading: false,
        success: true,
        data: action.payload
      },
      user: action.payload
    }
  }
  case types.LOGIN_USER_REJECTED: {
    return {
      ...state,
      login: {
        ...state.login,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.LOGOUT_USER_REQUESTED: {
    return {
      ...state,
      logout: {
        loading: true,
        success: false,
        error: false
      },
      login: {
        loading: false,
        success: false,
        error: false
      }
    }
  }
  case types.LOGOUT_USER_FULFILLED: {
    return {
      ...state,
      logout: {
        ...state.logout,
        loading: false,
        success: true
      },
      user: {}
    }
  }
  case types.LOGOUT_USER_REJECTED: {
    return {
      ...state,
      logout: {
        ...state.logout,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.FORGOT_PASSWORD_USER_REQUESTED: {
    return {
      ...state,
      forgotPassword: {
        loading: true,
        success: false,
        error: false,
        data: []
      }
    }
  }
  case types.FORGOT_PASSWORD_USER_FULFILLED: {
    return {
      ...state,
      forgotPassword: {
        ...state.forgotPassword,
        loading: false,
        success: true,
        data: action.payload
      }
    }
  }
  case types.FORGOT_PASSWORD_USER_REJECTED: {
    return {
      ...state,
      forgotPassword: {
        ...state.forgotPassword,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.VERIFY_USER_REQUESTED: {
    return {
      ...state,
      verifyUser: {
        loading: true,
        success: false,
        error: false
      }
    }
  }
  case types.VERIFY_USER_FULFILLED: {
    return {
      ...state,
      verifyUser: {
        ...state.verifyUser,
        loading: false,
        success: true
      },
      user: action.payload
    }
  }
  case types.VERIFY_USER_REJECTED: {
    return {
      ...state,
      verifyUser: {
        ...state.verifyUser,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.VALIDATE_USER_REQUESTED: {
    return {
      ...state,
      validateUser: {
        loading: true,
        success: false,
        error: false
      },
      login: {
        loading: false,
        success: false,
        error: false,
        data: []
      },
      getUser: {
        loading: false,
        success: false,
        error: false,
        data: {}
      }
    }
  }
  case types.VALIDATE_USER_FULFILLED: {
    return {
      ...state,
      validateUser: {
        ...state.validateUser,
        loading: false,
        success: true
      },
      user: action.payload
    }
  }
  case types.VALIDATE_USER_REJECTED: {
    return {
      ...state,
      validateUser: {
        ...state.validateUser,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.RESEND_CODE_REQUESTED: {
    return {
      ...state,
      resendCode: {
        loading: true,
        success: false,
        error: false
      }
    }
  }
  case types.RESEND_CODE_FULFILLED: {
    return {
      ...state,
      resendCode: {
        ...state.resendCode,
        loading: false,
        success: true
      }
    }
  }
  case types.RESEND_CODE_REJECTED: {
    return {
      ...state,
      resendCode: {
        ...state.resendCode,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.CHANGE_PASSWORD_USER_REQUESTED: {
    return {
      ...state,
      changePassword: {
        loading: true,
        success: false,
        error: false,
        data: []
      }
    }
  }
  case types.CHANGE_PASSWORD_USER_FULFILLED: {
    return {
      ...state,
      changePassword: {
        ...state.changePassword,
        loading: false,
        success: true,
        data: action.payload
      }
    }
  }
  case types.CHANGE_PASSWORD_USER_REJECTED: {
    return {
      ...state,
      changePassword: {
        ...state.changePassword,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.VERIFY_TOKEN_USER_REQUESTED: {
    return {
      ...state,
      verifyToken: {
        loading: true,
        success: false,
        error: false,
        data: []
      }
    }
  }
  case types.VERIFY_TOKEN_USER_FULFILLED: {
    return {
      ...state,
      verifyToken: {
        ...state.verifyToken,
        loading: false,
        success: true,
        data: action.payload
      }
    }
  }
  case types.VERIFY_TOKEN_USER_REJECTED: {
    return {
      ...state,
      verifyToken: {
        ...state.verifyToken,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.RESET_USER_STATE: {
    return {
      ...state,
      forgotPassword: {
        loading: false,
        error: false,
        success: false
      }
    }
  }
  default:
    return state
  }
}

export default userReducer
